<div class="preview-product-details">
  <div class="modal-header">
    <h4 class="modal-title" *ngIf="!isDisplayCalculatedConsumablesSummary">
      <ng-container *ngIf="!isStockAllocationSection && modelOrder?.type == constants.ORDER_TYPE_ORDER_SHORT">
        <span>Order Details: {{ modelOrder?.order_number }}</span>
      </ng-container>
      <ng-container *ngIf="!isStockAllocationSection && modelOrder?.type == constants.ORDER_TYPE_QUOTE_SHORT">
        <span>Quote Details: {{ modelOrder?.quote_number }}</span>
      </ng-container>
      <ng-container *ngIf="!isStockAllocationSection && modelOrder?.type == constants.ORDER_TYPE_SAMPLE_SHORT">
        <span>Sample Request Details: {{ modelOrder?.order_number }}</span>
      </ng-container>
      <ng-container *ngIf="isStockAllocationSection && modelOrder?.type == constants.ORDER_TYPE_ORDER_SHORT">
        <span>{{modelOrder?.project_name}} ({{ modelOrder?.order_number }})</span>
      </ng-container>
      <a [routerLink]="[getRedirectUrl(modelOrder)]" target="_blank" rel="noopener noreferrer" [tooltip]="'Open in new tab'" triggers="hover" (click)="$event.stopPropagation();" class="cursor-pointer redirect-img">
        <img src="/assets/admin/images/open-link-icon.svg" width="24" height="24" alt="open-link-icon">
      </a>
    </h4>
    <h4 class="modal-title" *ngIf="isDisplayCalculatedConsumablesSummary">Consumables Summary</h4>
    <span *ngIf="isCancelButtonEnabled" (click)="cancel()" [tooltip]="'Close'" style="cursor: pointer;">
      <i class="fa fa-times" aria-hidden="true"></i>
    </span>
  </div>
  <div class="modal-body">
    <div class="modal-body-inner">
      <div class="quote-order-detail-container">
        <div [class]="isLoading ? 'page-loader' : 'page-loader d-none'"></div>
        <div class="quote-detail-main">
          <div class="quote-detail-inner-container">
            <ng-container *ngIf="isStockAllocationSection">
              <div class="contact-wrap">
                <h3 class="quote-detail-title">Contact</h3>
                <div class="left-side">
                  <!--<label class="label">Contact</label>-->
                  <div class="name-and-role" [gcCopy]="modelOrder?.quoteOwner">
                    <strong>{{modelOrder?.quoteOwner?.first_name ?? ''}}
                      {{modelOrder?.quoteOwner?.last_name ?? ''}}</strong> {{modelOrder?.quoteOwner?.business_role?.name
                    ? '('+modelOrder?.quoteOwner?.business_role?.name+')' : ''}}
                  </div>
                  <div class="contact-dec" [gcCopy]="modelOrder?.company">{{modelOrder?.company?.company_name}}</div>
                </div>
                <div class="right-side">
                  <div class="required-date"><span class="label">Stock Required
                      Date:</span>{{modelOrder?.stock_required_date ? (modelOrder.stock_required_date | date: 'dd/MM/y')
                    : '-'}}</div>
                  <div class="order-date"><span class="label">Order Date:</span>{{modelOrder?.created_at ?
                    (modelOrder.created_at | date: 'dd/MM/y') : '-'}}</div>
                </div>
              </div>
              <ng-container *ngIf="modelOrder && !isLoading">
                <!-- <app-order-status-change-section [modelOrder]="modelOrder" [isOrderCancel]="isOrderCancel"></app-order-status-change-section> -->
                <div class="preview-milestones-status">
                  <app-milestones-status
                  [type]="constants.ORDER_TYPE_ORDER_SHORT"
                  [modelOrder]="{
                    quote_product: modelOrder.quote_product,
                    is_split_production: modelOrder.is_split_production,
                    is_split_delivery: modelOrder.is_split_delivery,
                    stock_required_date: modelOrder.stock_required_date,
                    status: modelOrder.status,
                    is_consumable_order: modelOrder.is_consumable_order
                    }"
                  [orderId]="modelOrderId"
                  [currentStatusId]="modelOrder.status_id"
                ></app-milestones-status>
                </div>
              </ng-container>
            </ng-container>

            @if(isStockAllocationSection) {
            <h3 class="quote-detail-title">Product Detail</h3>
            }
            <div class="sample-table-container"
              *ngIf="modelOrder?.quote_product?.length && !isDisplayCalculatedConsumablesSummary && type == constants.ORDER_TYPE_SAMPLE_SHORT">
              <app-product-detail [modelOrder]="modelOrder" [loginUserId]="loginUserId" [selectedUsers]="selectedUsers"
                [removedUsers]="removedUsers" [productDetail]="productDetail" [users]="users"
                (initializeQuillEditorEvent)="initializeQuillEditor($event)" [orderId]="modelOrderId"
                [isPreview]="true"></app-product-detail>
            </div>
            @if(type == constants.ORDER_TYPE_QUOTE_SHORT || type ==
            constants.ORDER_TYPE_ORDER_SHORT || isStockAllocationSection)
            {
            <div class="sample-table-container">
              <app-product-detail-section [modelOrder]="modelOrder" [isOrderCancel]="isOrderCancel"
                [loginUserId]="loginUserId" [selectedUsers]="selectedUsers" [removedUsers]="removedUsers"
                [productDetail]="productDetail" [users]="users" [s3BucketImageURL]="s3BucketImageURL"
                [updateQuillEditorsTrigger]="updateQuillEditorsTrigger"
                (initializeQuillEditorEvent)="initializeQuillEditor($event)"
                [isPreview]="true"></app-product-detail-section>
           </div>
            }
            <div class="quote-details pb-50">
              <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                  *ngIf="!isDisplayCalculatedConsumablesSummary">
                  <div class="quote-detail-widget" id="order_summary">
                    <h3 class="quote-detail-title" [ngClass]="{'collapsed':isOrderSummaryCollapsed}"
                      (click)="isOrderSummaryCollapsed = !isOrderSummaryCollapsed"
                      [attr.aria-expanded]="!isOrderSummaryCollapsed" aria-controls="collapse_order_summary">
                      Order Summary
                      <i class="fa fa-plus" aria-hidden="true"></i>
                    </h3>
                    <div class="order-summary-detail" id="collapse_order_summary"
                      [ngbCollapse]="isOrderSummaryCollapsed" data-parent="#order_summary">
                      @if(modelOrder) {
                      <app-order-summary [modelOrder]="modelOrder" [isPreviewDetail]="true"
                        [isQuoteAccepted]="isQuoteAccepted" />
                      }
                    </div>
                  </div>
                </div>
                <!-- The consumables summary is a bag/bottle breakdown derived from consumable
                     CALCULATORS on surface lines. A consumables-only quote has no surfaces and no
                     calculators, so it would render an all-zero table under a heading that makes no
                     sense next to the consumable lines already itemised above. -->
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 preview-consumables-summary" *ngIf="!isHideConsumablesSummary && modelOrder && !isConsumablesOnlyOrder">
                  <app-consumable-content [isDisplayExpandableContent]="isDisplayExpandableContent">
                    <ng-template #content>
                      <app-product-consumables-summary [consumableSummaryQuoteOrder]="modelOrder" [isPreview]="true" [isDisplayCalculatedConsumablesSummary]="isDisplayCalculatedConsumablesSummary" />
                    </ng-template>
                    <!-- <ng-template #content>
                      <table class="table table-bordered">
                        <tbody>
                          <tr>
                            <th scope="row">Product</th>
                            <th scope="row">Total Product</th>
                            <th>Units <br> <span>(20KG Bags)</span></th>
                            <th>Units <br> <span>(500 ML)</span></th>
                            <th>Units <br> <span>(2.5 L)</span></th>
                            <th>Units <br> <span>(5 L)</span></th>
                            <th>Units <br><span>(15 L)</span></th>
                            <th>Price <br> <span>(Ex. GST)</span></th>
                          </tr>
                          <ng-container>
                            <tr class="row-data-color">
                              <td style="font-weight: 700;">
                                Actichem CSD <br>
                                50 Defender
                              </td>
                              <td>
                                {{
                                consumableSummaryDetail?.totalDefender ?
                                consumableSummaryDetail?.totalDefender : 0 | number: '1.0-2'
                                }} <span>L</span>
                              </td>
                              <td>
                                {{
                                consumableSummaryDetail?.defender.twenty_kg_total_unit ?
                                consumableSummaryDetail?.defender.twenty_kg_total_unit : 0
                                }}
                              </td>
                              <td>
                                {{
                                consumableSummaryDetail?.defender.five_hundred_total_unit ?
                                consumableSummaryDetail?.defender.five_hundred_total_unit : 0
                                }}
                              </td>
                              <td>
                                {{
                                consumableSummaryDetail?.defender.two_thousand_five_hundred_total_unit ?
                                consumableSummaryDetail?.defender.two_thousand_five_hundred_total_unit : 0
                                }}
                              </td>
                              <td>
                                {{
                                consumableSummaryDetail?.defender.five_thousand_total_unit
                                ? consumableSummaryDetail?.defender.five_thousand_total_unit : 0
                                }}
                              </td>
                              <td>
                                {{
                                consumableSummaryDetail?.defender.fifteen_thousand_total_unit
                                ? consumableSummaryDetail?.defender.fifteen_thousand_total_unit : 0
                                }}
                              </td>
                              <td>
                                {{
                                (consumableSummaryDetail?.totalDefenderPrice
                                ? consumableSummaryDetail?.totalDefenderPrice : 0) | currency:'USD':'symbol'
                                }}
                              </td>
                            </tr>
                            <tr class="row-data-color">
                              <td style="font-weight: 700;">
                                Actichem Solv <br>
                                Sealer Gold
                              </td>
                              <td>
                                {{
                                consumableSummaryDetail?.totalGold ?
                                consumableSummaryDetail?.totalGold :
                                0 | number: '1.0-2'
                                }} <span>L</span>
                              </td>

                              <td>
                                {{
                                consumableSummaryDetail?.gold.twenty_kg_total_unit
                                ? consumableSummaryDetail?.gold.twenty_kg_total_unit : 0
                                }}
                              </td>

                              <td>
                                {{
                                consumableSummaryDetail?.gold.five_hundred_total_unit
                                ? consumableSummaryDetail?.gold.five_hundred_total_unit : 0
                                }}
                              </td>
                              <td>
                                {{
                                consumableSummaryDetail?.gold.two_thousand_five_hundred_total_unit
                                ? consumableSummaryDetail?.gold.two_thousand_five_hundred_total_unit : 0
                                }}
                              </td>
                              <td>
                                {{
                                consumableSummaryDetail?.gold.five_thousand_total_unit
                                ? consumableSummaryDetail?.gold.five_thousand_total_unit : 0
                                }}
                              </td>
                              <td>
                                {{
                                consumableSummaryDetail?.gold.fifteen_thousand_total_unit
                                ? consumableSummaryDetail?.gold.fifteen_thousand_total_unit : 0
                                }}
                              </td>
                              <td>
                                {{
                                (consumableSummaryDetail?.totalGoldPrice
                                ? consumableSummaryDetail?.totalGoldPrice : 0) | currency:'USD':'symbol'
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td style="font-weight: 700;">
                                Laticrete 335 <br>
                                Adhesive
                              </td>
                              <td>
                                {{
                                consumableSummaryDetail?.totalAdhesive ?
                                consumableSummaryDetail?.totalAdhesive :
                                0
                                }} <span>KG</span>
                              </td>
                              <td>
                                {{
                                consumableSummaryDetail?.laticrete_adhesive.twenty_kg_total_unit ?
                                consumableSummaryDetail?.laticrete_adhesive.twenty_kg_total_unit :
                                0
                                }}
                              </td>
                              <td>
                                {{
                                consumableSummaryDetail?.laticrete_adhesive.five_hundred_total_unit
                                ? consumableSummaryDetail?.laticrete_adhesive.five_hundred_total_unit : 0
                                }}
                              </td>
                              <td>
                                {{
                                consumableSummaryDetail?.laticrete_adhesive.two_thousand_five_hundred_total_unit
                                ?
                                consumableSummaryDetail?.laticrete_adhesive.two_thousand_five_hundred_total_unit
                                : 0
                                }}
                              </td>
                              <td>
                                {{
                                consumableSummaryDetail?.laticrete_adhesive.five_thousand_total_unit
                                ? consumableSummaryDetail?.laticrete_adhesive.five_thousand_total_unit : 0
                                }}
                              </td>
                              <td>
                                {{
                                consumableSummaryDetail?.laticrete_adhesive.fifteen_thousand_total_unit
                                ? consumableSummaryDetail?.laticrete_adhesive.fifteen_thousand_total_unit : 0
                                }}
                              </td>
                              <td>
                                {{
                                (consumableSummaryDetail?.totalAdhesivePrice
                                ? consumableSummaryDetail?.totalAdhesivePrice : 0) | currency:'USD':'symbol'
                                }}
                              </td>
                            </tr>
                            <tr class="no-border-bottom">
                              <td colspan="6" style="border: none"></td>
                              <td>
                                Total Price <br>
                                (Ex. GST)
                              </td>
                              <td>
                                {{
                                consumableSummaryDetail?.totalDefenderPrice
                                + consumableSummaryDetail?.totalGoldPrice +
                                consumableSummaryDetail?.totalAdhesivePrice
                                | currency:'USD':'symbol'
                                }}
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </ng-template> -->
                  </app-consumable-content>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer" *ngIf="!isStockAllocationSection">
    <ng-container *ngIf="isCancelButtonEnabled; else disabledCancelButton">
      <button type="button" class="dark-bordered-btn dont-send-btn" data-dismiss="modal" (click)="cancel()">Cancel
      </button>
    </ng-container>
    <button *ngIf="isDisplayCalculatedConsumablesSummary" class="btn grey-bg-btn add-note-btn" type="button"
      (click)="downloadConsummableSummaryPDF()">
      Download PDF
    </button>
    <button *ngIf="isDisplayCalculatedConsumablesSummary" class="btn grey-bg-btn add-note-btn" type="button"
      (click)="exportConsummableSummary()">
      Export
    </button>
    <ng-template #disabledCancelButton>
      <button type="button" class="dark-bordered-btn dont-send-btn disabled-button" data-dismiss="modal"
        [disabled]="isCancelButtonEnabled">Cancel
      </button>
    </ng-template>
  </div>
</div>
